import { useTranslation } from 'react-i18next'

import { formatSerialNumber } from '@/libs/utils/formatSerialNumber'

const SelectedMachine = ({ data }) => {
  const {
    id: machineId = '',
    name: machineName = '',
    serialNumber = '',
    image: machineImage = '',
    // machine category is only got from the machine page
    // currently machine page doesn't store to the redux
    machineCategory = null,
  } = data
  const { t } = useTranslation()

  return (
    <div className="selected-machine">
      <div className="selected-machine__image">
        <img alt={machineName} src={machineImage} />
      </div>
      <div className="selected-machine__information">
        <span>{machineCategory}</span>
        <span>{machineName}</span>
        <span>
          {`${t('service.serviceOverview.label.itemNumber')}: ${machineId}`}
        </span>
        <span>
          {`${
            t(
              'service.serviceOverview.label.serialNumber',
            )
          }: ${formatSerialNumber(serialNumber)}`}
        </span>
      </div>
    </div>
  )
}

export default SelectedMachine
